import { prismicClient } from "@jog/shared";
export const fetchService = (uid, previewData) => prismicClient({ previewData }).getByUID("service_page", uid, {
    fetchLinks: ["service_navigation.body"],
});
